<template>
  <PanelItem :index="index" :field="field">
    <template #value>
      <div class="flex items-center">
        <span
          class="mr-3 text-60"
          v-if="field.loadingWords?.includes(field.value)"
        >
          <loader width="30" />
        </span>

        <span
          v-if="field.value"
          :class="{ 'text-red-500': field.failedWords?.includes(field.value) }"
        >
          {{ field.value }}
        </span>
        <span v-else>&mdash;</span>
      </div>
    </template>
  </PanelItem>
</template>

<script>
export default {
  props: ['index', 'resource', 'resourceName', 'resourceId', 'field'],
}
</script>
